import type { Area } from 'react-easy-crop';

const OUTPUT_SIZE = 512;
const JPEG_QUALITY = 0.9;

function canvasToJpegBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error('Não foi possível recortar a foto.'));
      },
      'image/jpeg',
      JPEG_QUALITY,
    );
  });
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Não foi possível recortar a foto.'));
    image.src = src;
  });
}

export async function cropImageToJpeg(imageSrc: string, pixelCrop: Area): Promise<Blob> {
  // `<img>` / decode uses img-src (blob: already allowed). `fetch(blob:)` is
  // connect-src and is blocked by the staging nginx CSP.
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = OUTPUT_SIZE;
  canvas.height = OUTPUT_SIZE;
  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Não foi possível recortar a foto.');
  }

  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';
  context.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    OUTPUT_SIZE,
    OUTPUT_SIZE,
  );
  return canvasToJpegBlob(canvas);
}
